// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__5EC51","ttl":"styles_ttl__JVD6X","txt":"styles_txt__lOwmw","btn":"styles_btn__zScv+"};